import { FC } from 'react';
import ReportHubModal, { AllDropdowns } from '../../ReportHub/ReportHubModals/GenerateReport/ReportHubModal';
import { ReportSubtype } from '../../../models/Report';
import { Class } from '../../../models/Class';
import { useAppSelector } from '../../../redux/hooks';
import { selectUser } from '../../../redux/reducers/userSlice';
import { CustomBranding, mapCustomBranding } from '../../../models/User';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  allDropdowns: AllDropdowns;
  setAllDropdowns: (allDropdowns: AllDropdowns) => void;
  allClassesData: Class[];
}

const ProgressDetailedSkillReportContainer: FC<Props> = ({
  visible,
  setVisible,
  allDropdowns,
  setAllDropdowns,
  allClassesData,
}) => {
  const userRedux = useAppSelector(selectUser);
  const miamiBrand =
    (userRedux?.network?.customBranding &&
      mapCustomBranding[userRedux?.network?.customBranding] === CustomBranding.MIAMI) ||
    false;
  return (
    allDropdowns &&
    allClassesData && (
      <ReportHubModal
        visible={visible}
        setVisible={setVisible}
        selectedReportSubtype={ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT}
        allClassesData={allClassesData}
        allDropdowns={allDropdowns}
        setAllDropdowns={setAllDropdowns}
        isReduxFiltersUsed={true}
        miamiBrand={miamiBrand}
      />
    )
  );
};

export default ProgressDetailedSkillReportContainer;
